import _ from "lodash";
import React from "react";

import CardSecondary from "@/components/UI/Card/CardSecondary";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import images from "@/utils/images";
import { RATING_OPTION_LABEL_MAP } from "@/constants/rating";
import { TextArea } from "@/components/UI/StyledInput";

import { BehavioralGoalsRating } from "../../components/BehavioralGoalsRating";

export const PrescribeDiagnosisProgress = (props) => {
  const { editable, editHandler, note, profileView } = props;

  let diagnosisProgress = note.content.diagnosis_progress;

  const [isEditing, setIsEditing] = React.useState(false);
  const [editCopy, setEditCopy] = React.useState(_.cloneDeep(diagnosisProgress));

  const handleEditCopyChange = (e, index, key, isNumber = false) => {
    let editCopyClone = _.cloneDeep(editCopy);

    editCopyClone[index][key] = isNumber ? parseInt(e.target.value) : e.target.value;
    setEditCopy(editCopyClone);

    if (editHandler) {
      editHandler("diagnosis_progress", editCopyClone);
    }
  };

  let content = (
    <>
      <div className="row mx-1 px-1">
        <div className="col-lg-5">
          <p className="clr-sec tw:font-bold">Diagnosis</p>
        </div>
        <div className="col-lg-3 tw:font-bold">
          <p className="clr-sec tw:font-bold">Assessment</p>
        </div>

        <div className="col-lg-3 tw:font-bold">
          <div className="d-flex justify-content-between">
            <p className="clr-sec"> Plan</p>
            {editable && !isEditing && (
              <img
                alt="Edit Goals, Objectives, Progress"
                onClick={() => setIsEditing((curr) => !curr)}
                src={images("./icons/edit-2.svg")}
                style={{
                  height: "30px",
                  width: "30px",
                }}
              />
            )}

            {editable && isEditing && (
              <img
                alt="Save"
                onClick={() => {
                  setIsEditing((curr) => !curr);
                }}
                src={images("./icons/save.svg")}
                style={{
                  height: "30px",
                  width: "30px",
                }}
              />
            )}
          </div>
        </div>
      </div>

      {diagnosisProgress.map((progress, index) => {
        let style = { minHeight: 50 };

        if (index !== diagnosisProgress.length - 1) {
          style.borderBottom = "1px  solid #DAE6EC";
        } else if (index === diagnosisProgress.length - 1 && profileView) {
          style.borderBottom = "2px  solid #DAE6EC";
        }

        return (
          <div className="row mt-1 mx-1 px-1" key={index} style={style}>
            <div className="col-lg-5">
              <div>
                {index + 1}. {progress.label}
              </div>

              <div>
                <div className="col-12 d-flex justify-content-start">
                  {Object.values(RATING_OPTION_LABEL_MAP).map((optionLabel, labelIndex) => (
                    <div className="w-25 fs-10 text-center tw:font-bold" key={labelIndex}>
                      <div className="m-auto">{optionLabel}</div>
                    </div>
                  ))}
                </div>

                <BehavioralGoalsRating
                  isEditing={editable}
                  onClick={(e) => handleEditCopyChange(e, index, "answer", true)}
                  optionLabelMap={RATING_OPTION_LABEL_MAP}
                  progress={!editable ? progress : editCopy[index]}
                />
              </div>
            </div>

            <div className="col-lg-3">
              {!isEditing ? (
                <p>{progress.assessment}</p>
              ) : (
                <TextArea
                  onChange={(e) => handleEditCopyChange(e, index, "assessment")}
                  value={editCopy[index].assessment}
                />
              )}
            </div>

            <div className="col-lg-3">
              {!isEditing ? (
                <p>{progress.plan}</p>
              ) : (
                <TextArea
                  onChange={(e) => handleEditCopyChange(e, index, "plan")}
                  value={editCopy[index].plan}
                />
              )}
            </div>
          </div>
        );
      })}
    </>
  );

  let desktopContent;

  if (!profileView) {
    desktopContent = (
      <DashboardCard2 className="d-none d-md-none d-lg-block">{content}</DashboardCard2>
    );
  } else {
    desktopContent = <div>{content}</div>;
  }

  let mobileContent = (
    <div className="d-block d-md-block d-lg-none mt-3">
      <div className="d-flex justify-content-between">
        <p className="cmt-3 clr-sec tw:font-bold">Diagnosis</p>
        {editable && !isEditing && (
          <img
            alt="Diagnosis"
            onClick={() => setIsEditing((curr) => !curr)}
            src={images("./icons/edit-2.svg")}
            style={{
              height: "30px",
              width: "30px",
            }}
          />
        )}

        {editable && isEditing && (
          <img
            alt="Save"
            onClick={() => {
              setIsEditing((curr) => !curr);
            }}
            src={images("./icons/save.svg")}
            style={{
              height: "30px",
              width: "30px",
            }}
          />
        )}
      </div>

      {diagnosisProgress.map((progress, index) => {
        return (
          <CardSecondary className="mx-auto mt-2 px-3 py-3 d-block" key={index}>
            <div className="col-lg-3 tw:font-bold">
              <p className="clr-sec tw:font-bold">Diagnosis</p>
            </div>

            <div>
              {index + 1}. {progress.label}
            </div>

            <BehavioralGoalsRating
              isEditing={isEditing}
              onClick={(e) => handleEditCopyChange(e, index, "answer", true)}
              optionLabelMap={RATING_OPTION_LABEL_MAP}
              progress={progress}
            />

            <div className="col-lg-3 tw:font-bold">
              <p className="clr-sec tw:font-bold">Assessment</p>
            </div>
            <div className="col-lg-3">
              {!isEditing ? (
                <p>{progress.actions}</p>
              ) : (
                <TextArea
                  onChange={(e) => handleEditCopyChange(e, index, "assessment")}
                  value={editCopy[index].actions}
                />
              )}
            </div>

            <div className="col-lg-4 tw:font-bold">
              <p className="clr-sec tw:font-bold">Plan</p>
            </div>
            <div className="col-lg-3">
              {!isEditing ? (
                <p>{progress.plan}</p>
              ) : (
                <TextArea
                  onChange={(e) => handleEditCopyChange(e, index, "plan")}
                  value={editCopy[index].plan}
                />
              )}
            </div>
          </CardSecondary>
        );
      })}
    </div>
  );

  return (
    <>
      {desktopContent}
      {mobileContent}
    </>
  );
};
